<template>
  <div class="podcast-holder">
    <div class="podcast-square" :class="{ingrid: ingrid}">
      <div class="podcast-image">
        <ix-router-link :to="permalink"><img v-if="seen" :src="tileImageUrl" class="podcast-tile" :alt="item.title" 
          v-on:load="handleLoaded" :class="{loaded: loaded}" /></ix-router-link>
      </div>
    </div>
    <div class="podcast-panel">
      <div class="podcast-panel-title">
        <ix-router-link :to="permalink"><span v-html="item.title"></span></ix-router-link>
      </div>
      <div class="podcast-panel-summary" v-html="item.summary"></div>
    </div>
    <div style="flex-grow:1"></div>
    <div v-html="embedCode" class="sc-player" v-if="item.podcast_url && !small"></div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel'
import scf from './soundcloud-format.js'

export default {
  mixins: [ ViewablePanel ],
  props: {
    item: Object,
    ingrid: Boolean,
    animation: Boolean,
    small: Boolean
  },
  data () {
    return {
      artist: null,
      imsrc: '',
      loaded: false,
      embedCode: ''
    }
  },
  computed: {
    permalink () {
      if(this.item && this.item.permalink){
        let res = this.item.permalink.replace('/news/', '/podcasts/')
        return res
      }
      return ''
    },
    firstName: function () {
      if(this.artist) {
        let spl = this.artist.formatted_name.split(' ')
        if(spl.length > 0) return spl[0]
        return this.artist.formatted_name
      }
      return ''
    },
    tileImageUrl: function () {
      let timage = this.item.tile_image
      if(timage){
        timage = this.$k.forceFileExtension(timage, '.jpg')
        return this.$k.imagebase + 'images/news/' + this.item.news_id + '/700/' + timage
      }
      return this.$k.randomBlurry()
    }
  },
  created () {
    this.init()
  },
  methods: {
    handleLoaded () {
     
      this.loaded = true
    },
    getMatchingArtist (keys) {
      for(var item of keys) {
        let a = this.$store.getters.getMatchingArtist(item)
        if(a) return a
      }
      return null
    },
    async init () {
     
      let keys = this.item.tags.split('#')
      await this.$store.dispatch('fetchArtists')
      this.artist = this.getMatchingArtist(keys)
      if(this.inView) {
        if(this.item.podcast_url) {
          this.loadSoundcloudEmbed()
        }
      }
    },
    async handleInView () {
      if(this.inView){
        if(this.item.podcast_url && !this.embedCode && !this.small) {
          
          this.loadSoundcloudEmbed()
        }
      }
      
    },
    async loadSoundcloudEmbed()
    {
      this.embedCode = await scf.getEmbedCodeSmall(this.item.podcast_url)
    },
    goStory () {
      this.$emit('click', this.item)
    },
    visitPortfolio () {
      if(this.artist) {
        if(this.artist.animation) {
          this.$ixr.push(this.$k.getAnimPortfolioLink(this.artist))
        }
        else {
          this.$ixr.push(this.$k.getPortfolioLink(this.artist))
        }
        
      }
    }
  },
  watch: {
    item () {
      this.init()
    },
    inView () {
      this.handleInView()
    }
  }
}
</script>

<style>
.podcast-holder{
  width:49%;
  position:relative;
  margin-bottom:1.5%;
  background-color:#fff;
  display:flex;
  flex-direction: column;
  justify-content: space-between;
}

.podcast-square{
  position:relative;
  width:100%;
  /*
  padding-bottom:56%;
  height:0;
  */
}

.podcast-image{
  width:100%;
  height:auto;
  /*height: 0;
  padding-bottom:56%;
  position:absolute;
  overflow:hidden;*/
}

/*
.podcast-image img{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform: translate(-50%, -50%);
}
*/



.podcast-tile{
  opacity:0;
  transition:all 0.3s ease;
  width:100%;
}

.podcast-tile.loaded{
  opacity:1;
}

.podcast-panel{
  background-color:#fff;
  padding:20px 30px;
}

.podcast-panel-title{
  color:#ce0e2d;
  font-weight:500;
  font-size:19px;
  line-height:21px;
  margin-bottom:12px;
}

.podcast-panel-title a{
  color:#ce0e2d;
}

.podcast-panel-summary{
  font-size:17px;
  line-height:20px;
  margin-bottom:12px;
}

.podcast-holder .sc-player{
  background-color:#000;
  box-sizing: border-box;
  color:#fff;
  padding:10px;
  height:40px;
  overflow:hidden;
}

.podcast-holder .sc-player > div{
  display:none;
}

.h4 {
  font-size:21px;
  color:#666;
  margin:40px 0 10px 0;
}

</style>